// TODO: change the keys to more readablbe formate e.g.`MemberUnauthorized`
export enum Errno {
  MemberUnauthorized = 'ERR_AIFIAN_MEMBER_SERVICE_USER_NOT_AUTHENTICATED',
  ERR_TAPPAY_CREDIT_CARD_EXPIRED = 'ERR_TAPPAY_CREDIT_CARD_EXPIRED', // 信用卡過期
  ERR_TAPPAY_REQUEST_FAILED = 'ERR_TAPPAY_REQUEST_FAILED', // 執行TapPay API失敗
  ERR_TAPPAY_AMOUNT_MISMATCH = 'ERR_TAPPAY_AMOUNT_MISMATCH', // TapPay回傳的交易金額不符
  ERR_TAPPAY_UNRECOGNIZED_ERROR = 'ERR_TAPPAY_UNRECOGNIZED_ERROR', // 其它未辨識的TapPay錯誤訊息
  ERR_AIFIAN_PAYMENT_SERVICE_CREAM_INSTALMENT_PAYMENT_DENIED = 'ERR_AIFIAN_PAYMENT_SERVICE_CREAM_INSTALMENT_PAYMENT_DENIED', // 不允許支付該款項
  ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_MISMATCH = 'ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_MISMATCH', // 折抵金額和傳入的金額不符
  ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_NOT_ALLOWED = 'ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_NOT_ALLOWED', // 非會員無法使用折抵 或 該商品不得使用折抵
  ERR_AIFIAN_PRODUCT_SERVICE_SLASH_INACTIVE = 'ERR_AIFIAN_PRODUCT_SERVICE_SLASH_INACTIVE', // 目前未開放開團
  ERR_AIFIAN_PAYMENT_SERVICE_SLASH_INACTIVE = 'ERR_AIFIAN_PAYMENT_SERVICE_SLASH_INACTIVE', // 目前未開放付款
  // ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_ONLY // 只允許使用折抵付款

  ERR_SLASH_INSUFFICIENT_DISCOUNT_TOKEN = 'ERR_SLASH_INSUFFICIENT_DISCOUNT_TOKEN', // 回饋不足支付僅限折抵之商品
  ERR_SLASH_INSUFFICIENT_QTY = 'ERR_SLASH_INSUFFICIENT_QTY', // 商品庫存數量不足
  ERR_SLASH_PURCHASE_QTY_EXCEEDED = 'ERR_SLASH_PURCHASE_QTY_EXCEEDED', // 超過可購買之商品數量
  ERR_SLASH_ITEM_EXPIRED = 'ERR_SLASH_ITEM_EXPIRED', // 商品已截止付款
  ERR_SLASH_ITEM_CLOSED = 'ERR_SLASH_ITEM_CLOSED', // 商品已關閉
}

export enum ErrorMessages {
  ERR_AIFIAN_PRODUCT_SERVICE_WITHDRAW_AMOUNT_MISMATCH = '可用餘額有變動，請再試一次',
  ERR_AIFIAN_PRODUCT_SERVICE_WITHDRAW_INVALID_AMOUNT = '實際提領金額過小',
  ERR_AIFIAN_PRODUCT_SERVICE_WITHDRAW_INSUFFICIENT_ASSETS = '提領金額大於可提領金額',
  ERR_AIFIAN_PRODUCT_SERVICE_INSUFFICIENT_REWARD = '提領金額大於可提領金額',
  ERR_AIFIAN_PRODUCT_SERVICE_INSUFFICIENT_CASH = '提領金額大於可提領金額',
  ERR_AIFIAN_PRODUCT_SERVICE_SLASH_PERIODIC_PAYMENT_NOT_ALLOWED = '該連結已成功付款',
}

type ErrorMessagesType = keyof typeof ErrorMessages

const StatusErrorMessages = {
  409: '使用者已經存在',
  401: '使用者驗證錯誤，請重新整理頁面，若問題持續發生，請洽管理人員',
  404: '找不到該使用者',
  403: '使用者認證錯誤，請重新整理頁面，若問題持續發生，請洽管理人員',
}

type ErrnoStatus = keyof typeof StatusErrorMessages

const otherErrorMsg = '狀態錯誤，請重新整理頁面，若問題持續發生，請洽管理人員'

type RequestError = Error & {
  data: { errno?: string }
  status: ErrnoStatus
}

function getErrMsg(statusCode: ErrnoStatus): string {
  return StatusErrorMessages[statusCode] || otherErrorMsg
}

export function getErrorMessage(error: RequestError): string {
  const errno = error?.data?.errno as ErrorMessagesType
  if (errno) {
    return ErrorMessages[errno]
  }

  const status = error?.status
  if (status) {
    return getErrMsg(status)
  }

  return otherErrorMsg
}

export interface ErrorWithData extends Error {
  data: unknown
}

interface ErrorWithErrno extends ErrorWithData {
  data: {
    errno: unknown
  }
}

export interface AppError extends ErrorWithErrno {
  data: {
    errno: Errno
  }
}
// TODO: using `isAppError` along with `Errno` to replace the old way of checking error type
export function isAppError(error: unknown, matchesErrno: Errno): boolean {
  if (typeof error === 'object' && error !== null && 'data' in error) {
    const errorWithData = error as ErrorWithData
    if (
      typeof errorWithData.data === 'object' &&
      errorWithData.data !== null &&
      'errno' in errorWithData.data
    ) {
      const { errno } = (errorWithData as ErrorWithErrno).data
      if (typeof errno === 'string') {
        return errno === matchesErrno
      }
    }
  }
  return false
}
